import { useCallback, useContext } from 'react';
import { PerformanceAnalyticsContext } from './PerformanceAnalyticsProvider';
import { type AppPerformanceProfilingEvent } from './';
import { FrameProfilingEventCaptureTransformer } from './frameEventTransforms';

export const usePerformanceAnalytics = ({ isEnabled }: { isEnabled: boolean }) => {
	const { eventsRef } = useContext(PerformanceAnalyticsContext);

	// Use for out-of-frame capture in platform code.
	const captureEvent = useCallback(
		(event: AppPerformanceProfilingEvent) => {
			if (!isEnabled) {
				return;
			}
			eventsRef.current.push(event);
		},
		[isEnabled, eventsRef],
	);

	// Use for capturing events from untrusted sources (e.g. in-frame via bridge).
	const captureUntrustedEvent = useCallback(
		(event: unknown) => {
			if (!isEnabled) {
				return;
			}

			const result = FrameProfilingEventCaptureTransformer.safeParse(event);
			if (!result.success) {
				// TODO: log failed validations to detect contract mismatches/tampering.
				return;
			}

			captureEvent(result.data);
		},
		[isEnabled, captureEvent],
	);

	return { captureEvent, captureUntrustedEvent };
};
